module.exports = __webpack_public_path__ + "img/icon_card016.a640ef11.png";